export default __webpack_public_path__ + "static/media/p1-4.b1be7b33.png";